import { Injectable } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { IResponseBody } from 'src/app/interfaces/response-body';
import { ApiService } from 'src/app/services/api.service';
import { CommonFunctionService } from 'src/app/services/common-function.service';

@Injectable()
export class AuditLogApiService {
  constructor(protected Api: ApiService, protected commonFunctionService: CommonFunctionService) {}

  public listWithPageEvent(
    role: string, filter?: {}, PageEvent?: PageEvent
  ) {
    const endpoint = `${role}/audit-log`;
    const url = this.commonFunctionService.findApiUrl(role);
    return this.Api.getWithPageEventFilter(endpoint, PageEvent, filter, url).then(
      (ResponseBody: IResponseBody) => ResponseBody
    );
  }
}
